import { ValidationErrors, Validators } from '@angular/forms';
import { CustomValidators } from './custom-validators';
import { AccountAsyncMessageKeys } from './account-async-validator.service';

type AngularMessageKeys = Lowercase<keyof typeof Validators>;
type CustomMessageKeys = Lowercase<keyof typeof CustomValidators>;
type AsyncMessageKeys = Lowercase<AccountAsyncMessageKeys>;
type CustomFallbackKeys = 'invalid' | 'alreadyExist';
type MessageOptions = Partial<
  Record<AngularMessageKeys | CustomMessageKeys | AsyncMessageKeys | CustomFallbackKeys, string>
>;

export class ControlMessages {
  static getErrorMessage<T = MessageOptions>(
    fieldName: string | string[],
    control: any,
    error: string
  ): ValidationErrors | null {
    const field = Array.isArray(fieldName)
      ? ControlMessages.joinWithOr(fieldName.map((f) => f.trim()))
      : fieldName || 'Campo';

    const messages: MessageOptions = {
      required: `${field} é obrigatório.`,
      minlength: `${field} deve ter no mínimo ${control.errors?.minlength?.requiredLength} caracteres.`,
      maxlength: `${field} deve ter no máximo ${control.errors?.maxlength?.requiredLength} caracteres.`,
      email: `${field} deve ser um endereço de e-mail válido.`,
      pattern: `${field} incorreto.`,
      min: `${field} deve ser maior ou igual a ${control.errors?.min?.min}.`,
      max: `${field} deve ser menor ou igual a ${control.errors?.max?.max}.`,
      nullvalidator: `${field} não pode ser nulo.`,
      password: `${field} deve conter pelo menos 8 caracteres, incluindo 1 letra maiúscula, 1 letra minúscula, 1 número e 1 caractere especial.`,
      atleastonefilled: `Ao menos um dos campos ${field} devem ser preenchidos`,
      accountalreadyexists: `${field} já utilizado em outra conta`,
      asyncvalidationerror: `Erro ao validar ${field}. Tente novamente mais tarde.`,
      invalid: `${field} inválido.`,
      confirmation: `Confirmação de ${field} devem ser iguais.`,
      requiredcheckbox: `Você precisa aceitar ${field}`,
      alreadyExist: `${field} já cadastrado.`,
    };

    const message = messages[error as AngularMessageKeys | CustomMessageKeys];

    return message
      ? {
          [error]: message,
        }
      : null;
  }

  static joinWithOr(fields: string[]): string {
    if (fields.length === 0) return 'Campo';
    if (fields.length === 1) return fields[0];
    return fields.slice(0, -1).join(', ') + ' ou ' + fields[fields.length - 1];
  }
}
